import { useEffect, type ReactNode } from 'react';

import css from './Hoja.module.css';

/**
 * Hoja inferior para lo que se pide sin salir de la pantalla: el motivo de una
 * estancia no accesible, una incidencia, el código manual del apartamento.
 *
 * Sube desde abajo porque es donde está el pulgar. Y se cierra con Escape para
 * cuando alguien la abre desde un teclado externo probando la app.
 */
export function Hoja({
    titulo,
    ayuda,
    children,
    alCerrar,
}: {
    titulo: string;
    ayuda?: string | undefined;
    children: ReactNode;
    alCerrar: () => void;
}) {
    useEffect(() => {
        const tecla = (e: KeyboardEvent): void => {
            if (e.key === 'Escape') {
                alCerrar();
            }
        };
        addEventListener('keydown', tecla);

        return () => removeEventListener('keydown', tecla);
    }, [alCerrar]);

    return (
        <div
            className={css.fondo}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    alCerrar();
                }
            }}
        >
            <div className={css.hoja} role="dialog" aria-modal="true" aria-label={titulo}>
                <h2 className={css.titulo}>{titulo}</h2>
                {ayuda !== undefined && <p className={css.ayuda}>{ayuda}</p>}
                {children}
            </div>
        </div>
    );
}

export const estilosHoja = css;
